// Wählt die Firebase-Web-Config anhand von REACT_APP_FIREBASE_ENV. Die
// Configs stehen in firebase-umgebungen.json, das auch
// scripts/frontend-umgebung.js liest, damit Build und Start schon vor
// react-scripts abbrechen.
import umgebungen from "./firebase-umgebungen.json";

const erlaubt = Object.keys(umgebungen).join(", ");

export const waehleFirebaseConfig = (umgebung) => {
  if (!umgebung) {
    throw new Error(
      `REACT_APP_FIREBASE_ENV fehlt. Erlaubt sind: ${erlaubt}.`
    );
  }
  if (!Object.prototype.hasOwnProperty.call(umgebungen, umgebung)) {
    throw new Error(
      `REACT_APP_FIREBASE_ENV '${umgebung}' ist unbekannt. Erlaubt sind: ${erlaubt}.`
    );
  }
  return umgebungen[umgebung];
};
